export enum UFEnum {
    AC = 'AC',
    AL = 'AL',
    AP = 'AP',
    AM = 'AM',
    BA = 'BA',
    CE = 'CE',
    DF = 'DF',
    ES = 'ES',
    GO = 'GO',
    MA = 'MA',
    MT = 'MT',
    MS = 'MS',
    MG = 'MG',
    PA = 'PA',
    PB = 'PB',
    PR = 'PR',
    PE = 'PE',
    PI = 'PI',
    RJ = 'RJ',
    RN = 'RN',
    RS = 'RS',
    RO = 'RO',
    RR = 'RR',
    SC = 'SC',
    SP = 'SP',
    SE = 'SE',
    TO = 'TO'
}

export const UFNomes: { [key in UFEnum]: string } = {
    [UFEnum.AC]: 'Acre',
    [UFEnum.AL]: 'Alagoas',
    [UFEnum.AP]: 'Amapá',
    [UFEnum.AM]: 'Amazonas',
    [UFEnum.BA]: 'Bahia',
    [UFEnum.CE]: 'Ceará',
    [UFEnum.DF]: 'Distrito Federal',
    [UFEnum.ES]: 'Espírito Santo',
    [UFEnum.GO]: 'Goiás',
    [UFEnum.MA]: 'Maranhão',
    [UFEnum.MT]: 'Mato Grosso',
    [UFEnum.MS]: 'Mato Grosso do Sul',
    [UFEnum.MG]: 'Minas Gerais',
    [UFEnum.PA]: 'Pará',
    [UFEnum.PB]: 'Paraíba',
    [UFEnum.PR]: 'Paraná',
    [UFEnum.PE]: 'Pernambuco',
    [UFEnum.PI]: 'Piauí',
    [UFEnum.RJ]: 'Rio de Janeiro',
    [UFEnum.RN]: 'Rio Grande do Norte',
    [UFEnum.RS]: 'Rio Grande do Sul',
    [UFEnum.RO]: 'Rondônia',
    [UFEnum.RR]: 'Roraima',
    [UFEnum.SC]: 'Santa Catarina',
    [UFEnum.SP]: 'São Paulo',
    [UFEnum.SE]: 'Sergipe',
    [UFEnum.TO]: 'Tocantins'
};
